// "COULDN'T READ" OPTIONS (ADR-0051 update 2026-10-15) — the calls the admin
// and seller portals share. No React here: each app wraps these in its own
// react-query hooks.
import { api } from './client';
import type { IngestFinalizeRequest, IngestFinalizeResponse } from './types';

/**
 * The ORIGINAL file as a download: the content endpoint's own rules (the room
 * admin and the bound seller get the stored bytes; a buyer never reaches this —
 * their copy is their buyer copy). Same origin, cookie-authenticated.
 */
export function documentDownloadPath(roomId: string, documentId: string): string {
  return `/api/v1/rooms/${roomId}/documents/${documentId}/content?download=1`;
}

/**
 * "Upload a replacement": the finalize body, stored as a NEW VERSION of the
 * flagged document (`POST …/readable-copy`, the admin or the bound seller) — the
 * flag goes with the old version and the new one is read and filed like any
 * upload. 409 when it is the same unreadable file again, or the file was read.
 */
export function uploadReplacement(
  roomId: string,
  documentId: string,
  body: IngestFinalizeRequest,
): Promise<IngestFinalizeResponse> {
  return api.post<IngestFinalizeResponse>(
    `/rooms/${roomId}/documents/${documentId}/readable-copy`,
    body,
  );
}

export interface ClearUnreadableFlagResponse {
  documentId: string;
  /** The seller had been asked for a readable copy; that request is withdrawn. */
  sellerRequestWithdrawn: boolean;
}

/** "It opens fine — clear the flag" (the room admin only; audited server-side). */
export function clearUnreadableFlag(
  roomId: string,
  documentId: string,
): Promise<ClearUnreadableFlagResponse> {
  return api.post<ClearUnreadableFlagResponse>(
    `/rooms/${roomId}/documents/${documentId}/unreadable/clear`,
  );
}
